import React from 'react';
import { CodeSnippet, WarningPanel } from '@backstage/core-components';

/**
 * Props for {@link CatalogError}.
 *
 * @public
 */
export interface CatalogErrorProps {
  error: Error;
}

/** @public */
export const CatalogError = (props: CatalogErrorProps) => {
  return (
    <div>
      <WarningPanel severity="error" title="Could not fetch catalog entities.">
        <CodeSnippet language="text" text={props.error.toString()} />
      </WarningPanel>
    </div>
  );
};
